<template>
  <v-section flat class="mx-auto">
    <span class="text-4">4</span><span class="text-0">0</span
    ><span class="text-4">4</span>
    <v-card-text class="font-weight-bold">
      THE PAGE YOU REQUESTED NOT FOUND.
    </v-card-text>
  </v-section>
</template>

<script>
export default {
  data() {
    return {
      back_path: "",
      btn_value: "",
    };
  },
  mounted() {
    const is_token = sessionStorage.getItem("access_token");
    if (is_token) {
      this.back_path = "/home";
      this.btn_value = "GO TO HOME PAGE";
    } else {
      this.back_path = "/login";
      this.btn_value = "GO TO BACK";
    }
  },
};
</script>

<style lang="scss">
@import "@/global.scss";
.text-4 {
  font-size: 150px;
  font-weight: bold;
}

.text-0 {
  font-size: 150px;
  font-weight: bold;
  color: $primary;
}
</style>
